import { createContext, useCallback, useContext, useState, type ReactNode } from "react";

type ToastKind = "ok" | "warn" | "err";
type ToastItem = { id: number; message: string; kind?: ToastKind };

const ToastContext = createContext<((message: string, kind?: ToastKind) => void) | null>(null);

export function ToastProvider({ children }: { children: ReactNode }) {
  const [items, setItems] = useState<ToastItem[]>([]);

  const show = useCallback((message: string, kind?: ToastKind) => {
    const id = Date.now() + Math.random();
    setItems((cur) => [...cur, { id, message, kind }]);
    setTimeout(() => setItems((cur) => cur.filter((i) => i.id !== id)), 2400);
  }, []);

  return (
    <ToastContext.Provider value={show}>
      {children}
      <div className="toast-stack" aria-live="polite">
        {items.map((i) => (
          <div key={i.id} className={`toast${i.kind ? ` ${i.kind}` : ""}`}>{i.message}</div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export function useToast(): (message: string, kind?: ToastKind) => void {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error("useToast must be used within ToastProvider");
  return ctx;
}
